"use client";

import dynamic from "next/dynamic";

const AnnouncementBarLazy = dynamic(
  () =>
    import("@/components/AnnouncementBar").then((m) => ({
      default: m.AnnouncementBar,
    })),
  { ssr: false }
);

export function AnnouncementBarLoader() {
  return <AnnouncementBarLazy />;
}
